import PropTypes from "prop-types";

function P2TextTabs(props) {
  return (
    <div className="polymer-text-tabs-container">
      {props.titles.map((item, _index) => (
        <div
          key={_index}
          onClick={() => {
            if (props.onChange) {
              props?.onChange(_index);
            }
          }}
          className={`polymer-text-tabs-item ${
            props.selectedTabIndex === _index
              ? "polymer-text-tabs-item__selected"
              : ""
          }`}
        >
          {item}
        </div>
      ))}
    </div>
  );
}

export default P2TextTabs;

P2TextTabs.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.string),
  selectedTabIndex: PropTypes.number,
  onChange: PropTypes.func,
};

P2TextTabs.defaultProps = {
  titles: [],
  selectedTabIndex: 0,
};
